import { Directive, ElementRef, Input, NgModule, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { debounceTime, map, share } from 'rxjs/operators';

const windowScrolled: Observable<number> = fromEvent(window, 'scroll').pipe(
  debounceTime(100),
  map(() => window.pageYOffset),
  share(),
);

@Directive({
  selector: '[toAffix]'
})
export class AffixDirective implements OnInit, OnDestroy {
  @Input() toAffix: number;
  private _isAffixed = false;

  private _subscription: Subscription;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private zone: NgZone,
  ) { }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      this._subscription = windowScrolled.subscribe(scrollTop => {
        if (scrollTop > this.toAffix) {
          if (!this._isAffixed) {
            this._isAffixed = true;
            this.renderer.addClass(this.el.nativeElement, 'affix');
          }
        } else if (this._isAffixed) {
          this._isAffixed = false;
          this.renderer.removeClass(this.el.nativeElement, 'affix');
        }
      });
    });
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}

@NgModule({
  declarations: [AffixDirective],
  exports: [AffixDirective]
})
export class AffixModule { }
